import { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AutoZoom from './AutoZoom';
import { compose } from 'recompose';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import Events from '../../../../../../utilities/EventEmitter';

const styles = (theme) => ({
  headerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${theme.AppBGColor}`,
    marginBottom: 1,
    borderRadius: '4px 4px 0 0',
    padding: '9px 9px',
    fontSize: theme.headerTextFontSize,
    lineHeight: '16px',
    color: theme.HeaderSelectedText
  },
  label: {
    marginLeft: 6
  }
});

const MapHeader = ({ classes, label, userData, setRouteAnimation = null }) => {
  const [isAutoZoomEnabled, setIsAutoZoomEnabled] = useState(true);
  useEffect(() => {
    Events.on('routeAnimationPopup', toggleRouteAnimation);
    return () => {
      Events.off('routeAnimationPopup', toggleRouteAnimation);
    };
  }, []);
  const toggleRouteAnimation = (value) => {
    setRouteAnimation?.(value); //Required only for PickupRoute
    setIsAutoZoomEnabled(value);
  };
  return (
    <div className={classes.headerStyle}>
      <span className={classes.label}>{label}</span>
      <span>
        <AutoZoom
          isEnabled={isAutoZoomEnabled}
          toggleRouteAnimation={toggleRouteAnimation}
          userData={userData}
        />
      </span>
    </div>
  );
};

export default compose(withStyles(styles), withUserProfile)(MapHeader);
